import React from 'react';
import styled from 'styled-components';
import ChatSettings from '../ChatSettings';

const Header = styled.div`
  margin-bottom: 24px;

  h2 {
    margin: 0 0 6px;
    font-family: ${({ theme }) => theme.fonts.display};
    font-style: italic;
    font-weight: 500;
    font-size: 2rem;
    letter-spacing: -0.02em;
    color: ${({ theme }) => theme.colors.text.primary};
  }

  p {
    margin: 0;
    color: ${({ theme }) => theme.colors.text.secondary};
    font-size: 0.95rem;
  }
`;

const Card = styled.div`
  background: ${({ theme }) => theme.colors.surface};
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: 12px;
  overflow: hidden;
`;

const ChatbotAIPage = () => (
  <>
    <Header>
      <h2>Chatbot AI</h2>
      <p>System prompt for the chat bubble assistant on the public site.</p>
    </Header>
    <Card>
      <ChatSettings embedded />
    </Card>
  </>
);

export default ChatbotAIPage;
